import React from 'react';
import "./LegalImpressum.css";

const LegalImpressum = () => {
  return (
    <div className="legal-impressum">
      <h1>Jogi Impresszum</h1>

      <h2>Szolgáltató adatai</h2>
      <p><strong>Cégnév:</strong> Császár Travel Kft.</p>
      <p><strong>Székhely:</strong> 8868 Murarátka, Hunyadi János utca 1.</p>
      <p><strong>Postacím:</strong> 8868 Murarátka, Hunyadi János utca 1.</p>
      <p><strong>Adószám:</strong> 32765179-2-20</p>
      <p><strong>Cégjegyzékszám:</strong> 20-09-079589</p>
      <p><strong>Képviseli:</strong> Császár Krisztina</p>
      <p><strong>Email:</strong> info@csaszartravel.hu</p>
      <p><strong>Telefon:</strong> +36 30 182 72 02</p>

      <h2>Adatkezelés</h2>
      <p>
        A weboldalon történő adatrögzítés (pl. utazásra jelentkezés, hírlevél-feliratkozás) során kizárólag a megadott információkat kezeljük, az <strong>adatkezelési tájékoztatónak</strong> megfelelően. 
        A jelentkezéseket 30 napig tároljuk, azt követően automatikusan töröljük. 
        Hírlevél-feliratkozás esetén csak az email címet rögzítjük, amelyet kizárólag marketing célra használunk fel, és bármikor törölhető.
      </p>

      <h2>Cookie-k</h2>
      <p>
        A weboldal cookie-kat (sütiket) használ a felhasználói élmény javítása és a működés biztosítása érdekében. A cookie-k nem tartalmaznak személyes adatokat, és a böngésző beállításaiban bármikor törölhetők vagy letilthatók.
      </p>

      <h2>Szerzői jogok</h2>
      <p>
        A weboldalon található szöveges és vizuális tartalmak, beleértve a képeket, leírásokat, logókat és egyéb grafikai elemeket, szerzői jogvédelem alatt állnak. Ezek engedély nélküli másolása, terjesztése vagy felhasználása jogi következményeket vonhat maga után.
      </p>

      <h2>Felelősségkizárás</h2>
      <p>
        Az oldalon található tartalom tájékoztató jellegű. A szolgáltató nem vállal felelősséget az esetleges elírásokért, pontatlanságokért vagy a technikai hibákból adódó kellemetlenségekért.
      </p>

      <p><strong>Utolsó frissítés:</strong> 2025. április</p>
    </div>
  );
};

export default LegalImpressum;
